"use client";
import { motion } from "framer-motion";
import { PortfolioDesktop } from "./PortfolioDesktop";
import PortfolioMobile from "./PortfolioMobile";
import Container from "components/Container";

export default function Portfolio() {
    return (
        <motion.section id="portfolio" className="pt-12 pb-20 md:py-24 lg:py-0 lg:h-screen lg:flex flex-col"
        >
            <PortfolioDesktop />
            <PortfolioMobile />
            <Container className="lg:mt-6 lg:mb-auto xl:mt-8 4xl:mt-12">
                <div className="flex justify-center lg:justify-start">
                    <a className="bg-smoke text-neutral-50 py-2 px-4 md:py-3 md:px-5 text-base md:text-xl" href="/portfolio">
                        More Portfolio
                    </a>
                </div>
            </Container>
        </motion.section>
    );
}
